import { useTypesStore } from "../store/Types.js";
import { useTypesRender } from "../utils/useRender.js";
export var True = props => {
  var {
    True: Comp = {}
  } = useTypesStore();
  useTypesRender(Comp, props, 'True');
  return null;
};
True.displayName = 'JVR.True';